// Angular
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BaseComponent } from './views/theme/base/base.component';
import { ErrorPageComponent } from './views/theme/content/error-page/error-page.component';
import { AuthGuard } from './core/auth';
import { WebformComponent } from './views/pages/webform/webform.component';
import { CusWebpageauthGuard } from './core/auth/_guards/cuswebpageauth.guard';
import { ReportModuleModule } from './views/pages/report-module/report-module.module';
const routes: Routes = [
	{
		path:'auth', loadChildren: () => import('./views/pages/auth/auth.module').then(m => m.AuthModule)},
		{ 
			path : 'customer/webform', 
			component : WebformComponent, 
			canActivate:[CusWebpageauthGuard],
			data: {returnUrl: window.location.pathname}           //added by sowmiya for customer webform
		  },
{
		path: '',
		component: BaseComponent,
		canActivate: [AuthGuard],
		children: [
			{
			    path:'all', loadChildren: () => import('./views/pages/all-shared/all-shared.module').then(m => m.AllSharedModule)
			},
			{
				path:'trc', loadChildren: () => import('./views/pages/trcadminmodule/trcadminmodule.module').then(m => m.TrcadminmoduleModule)
			},
			{
			    path:'customer', loadChildren: () => import('./views/pages/bimmodule/bimmodule.module').then(m => m.BimmoduleModule)
			},
			{
			    path:'report', loadChildren: () => import('./views/pages/report-module/report-module.module').then(m => m.ReportModuleModule)
			},			
				{
				path: 'error/403',
				component: ErrorPageComponent,
				data: {
					'type': 'error-v6',
					'code': 403,
					'title': '403... Access forbidden',
					'desc': 'Looks like you don\'t have permission to access for requested page.<br> Please, contact administrator'
				}
			},

		]
	},
	

];

@NgModule({
	imports: [
		RouterModule.forRoot(routes)
	],
	exports: [RouterModule]
})
export class AppRoutingModule {
}
